export const environment = {
  production: false,
  staging: true,
  apiHost: 'https://declunk-back-staging.onrender.com',
  apiWsUrl: 'wss://declunk-back-staging.onrender.com'
};
